import { useCookie } from "@/composables";
import { AUTH_TOKEN_COOKIE } from "@/constants/auth";
import { buildLoginLocation, readRedirectTarget } from "@/utils/authRedirect";

export const AuthorizedGuard = (to) => {
  const tokenStorage = useCookie(AUTH_TOKEN_COOKIE);
  if (tokenStorage.get() === null) {
    return buildLoginLocation(readRedirectTarget(to.fullPath));
  }
  return true;
};
